import { DialogM } from "@common/components/alert/dialog/Dialog"
import { liveTimesLabel } from "./maDispoSlot"

/**
 * Raised by « Libérer des créneaux » before « Tes élèves » when the preview may
 * cost him students, so the loss reads before the detail of each card.
 */
export const showReleaseLossWarning = (count, onContinue) =>
    DialogM.show({
        text1: count > 1 ? `Tu risques de perdre ${count} élèves` : "Tu risques de perdre un élève",
        text2: `${count > 1 ? "Ces élèves peuvent" : "Cet élève peut"} passer à un autre tuteur. Regarde ce qui change pour chacun avant de confirmer.`,
        buttonText1: "Voir l'impact",
        onPress: onContinue,
        buttonText3: "Revenir",
        onPress3: () => {},
        exitButton: true,
        onPressBack: () => {},
    })

/**
 * The warning raised when the tutor taps an ENGAGED créneau — shared by the
 * standalone « Ma dispo » screen and the profile stepper step.
 *
 * Single owner because the copy is load-bearing: it must point to the absence
 * request and must never suggest that failing to confirm could cost the tutor
 * their live or their group. What the tutor reads cannot depend on which screen
 * they tapped from.
 *
 * Names the live's own start when the slot carries it: the chip sits on the grid
 * hour that contains the live, so on an off-hour live the tutor is looking at a
 * « 18h » cell for something that starts at 18h30 — and the dialog is where there
 * is room to say so.
 *
 * With `onRelease`, the tutor who can no longer give the créneau at all is
 * offered « Libérer des créneaux »; an absence stays the answer for one date.
 */
export const showEngagedSlotWarning = (slot, onRelease) => {
    const live = `Ce créneau accueille un live${liveTimesLabel(slot?.live_times)}.`

    if (!onRelease) {
        DialogM.show({
            text1: "Créneau réservé à un live",
            text2: `${live} Pour le libérer, fais une demande d'absence.`,
            buttonText1: "J'ai compris",
            exitButton: true,
            onPress: () => {},
            onPressBack: () => {},
        })
        return
    }

    DialogM.show({
        text1: "Créneau réservé à un live",
        text2: `${live} Pour une absence ponctuelle, fais une demande d'absence depuis ce live.`,
        buttonText1: "Je ne peux plus assurer ce créneau",
        onPress: () => onRelease(slot),
        buttonText3: "J'ai compris",
        onPress3: () => {},
        exitButton: true,
        onPressBack: () => {},
    })
}
